// Importing constants
import { POPUP_ENUM } from '../../utils/constants/commonValues';

// Importing components
import DefendChargebackForm from './DefendChargebackForm';
import ExtendChargeBackDeadlineForm from './ExtendChargeBackDeadlineForm';
import UpdateChargeBackStatusForm from './UpdateChargeBackStatusForm';

// Importing Libraries
import React from 'react';
import PropTypes from 'prop-types';
import UpdateDisputeForm from './UpdateDisputeForm';

export const ChargeBackModalComponents = ({
    component,
    onClose,
    onSubmit,
    subChargebackDetails,
    transactionData,
    chargebackAgentAction,
    currentChargebackStatus,
    chargebackMetaData,
    isLoading
}) => {
    if (!component) {
        return <></>;
    } else if (component === POPUP_ENUM.UPDATE_FORM) {
        return (
            <UpdateChargeBackStatusForm
                onClose={onClose}
                onSubmit={onSubmit}
                chargebackAgentAction={chargebackAgentAction}
                currentChargebackStatus={currentChargebackStatus}
                chargebackMetaData={chargebackMetaData}
            />
        );
    } else if (component === POPUP_ENUM.EXTEND_DEADLINE_FORM) {
        return (
            <ExtendChargeBackDeadlineForm
                onClose={onClose}
                onSubmit={onSubmit}
            />
        );
    } else if (component === POPUP_ENUM.CHARGEBACK_DEFEND) {
        return (
            <DefendChargebackForm
                onClose={onClose}
                onSubmit={onSubmit}
                subChargebackDetails={subChargebackDetails}
                transactionData={transactionData}
            />
        );
    } else if (component === POPUP_ENUM.UPDATE_DISPUTE) {
        return (
            <>
                <UpdateDisputeForm isLoading={isLoading}
                    onClose={onClose}
                    onSubmit={onSubmit}
                    transactionData={transactionData}
                    initialValues={{
                        refundType: 'ACCEPTED',
                    }}
                />
            </>
        );
    }

    return <></>;
};

// PropType validation for ChargeBackModalComponents component
ChargeBackModalComponents.propTypes = {
    actions: PropTypes.object,
    transactionData: PropTypes.object,
    currentChargebackStatus: PropTypes.string,
    onClose: PropTypes.func,
    onSubmit: PropTypes.func,
    component: PropTypes.string,
    subChargebackDetails: PropTypes.object,
    chargebackAgentAction: PropTypes.object,
};
